// ///////////////////////////////////////////////////////////////////////////////
// NOTA BENE:                                                                   //
//                                                                              //
// These numbers come from the Illustrator .ai files, from the exact dimensions //
// of the picture blocks. They are used here to get the exact ratio, eg. 97/190 //
// and not 51% or 51.05% or whichever decimal one wishes to stop at.            //
//                                                                              //
// ///////////////////////////////////////////////////////////////////////////////

const XS = 'XS';
const S = 'S';
const M = 'M';
const L = 'L';
const XL = 'XL';
const XXL = 'XXL';
const R_38_BY_28 = 'R_38_BY_28';
const R_38_BY_58 = 'R_38_BY_58';
const R_63_BY_58 = 'R_63_BY_58';
const R_65_BY_48 = 'R_65_BY_48';
const R_13_BY_12 = 'R_13_BY_12';

const values = {
  [XS]: 180 / 580,
  [S]: 118 / (380 - 118),
  [M]: 194 / 380,
  [L]: 9 / 16,
  [XL]: 240 / 380,
  [XXL]: 320 / 480,
  [R_38_BY_28]: 380 / 280,
  [R_38_BY_58]: 380 / 580,
  [R_63_BY_58]: 63 / 58,
  [R_65_BY_48]: 65 / 48,
  [R_13_BY_12]: 13 / 12,
};

export default {
  values,
  XS,
  S,
  M,
  L,
  XL,
  XXL,
  R_38_BY_28,
  R_38_BY_58,
  R_63_BY_58,
  R_65_BY_48,
  R_13_BY_12,
};
